import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from './config';

/**
 * Resolving a content-pack media path to something a browser can fetch (§16).
 *
 * The pack stores storage paths — `audio/{orgId}/{scenarioId}/{nodeId}_{variant}.mp3`
 * — not URLs, because a download URL carries a token that would go stale and
 * would have to be re-seeded every time media was regenerated. The path is the
 * stable name; the URL is derived at read time.
 *
 * Resolution is per-path and memoized for the life of the tab. That is a plain
 * module-level Map, not browser storage: nothing survives the tab closing, which
 * is what §22.2 requires.
 */
const cache = new Map<string, Promise<string>>();

export function mediaUrl(path: string): Promise<string> {
  const hit = cache.get(path);
  if (hit) return hit;
  const pending = getDownloadURL(ref(storage, path)).catch((err) => {
    // A missing clip must not be sticky: audio is optional and the pipeline may
    // simply not have run for this line yet, so the next tap tries again.
    cache.delete(path);
    throw err;
  });
  cache.set(path, pending);
  return pending;
}
